import React from 'react';
import { useIntl } from 'react-intl';

const GameIntro = () => {
  const intl = useIntl();

  const scrollToGame = () => {
    const gameElement = document.getElementById('game-area');
    if (gameElement) {
      gameElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-12 md:py-20 bg-gradient-to-r from-indigo-100 to-purple-100">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <h2 className="text-4xl md:text-5xl font-bold text-indigo-800 mb-4">{intl.formatMessage({ id: 'home.title' })}</h2>
            <p className="text-xl text-gray-600 mb-6">
              {intl.formatMessage({ id: 'home.description' })}
            </p>
            <div className="space-y-4">
              <h3 className="text-2xl font-semibold text-indigo-700">{intl.formatMessage({ id: 'home.howToPlay.title' })}</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>{intl.formatMessage({ id: 'home.howToPlay.item1' })}</li>
                <li>{intl.formatMessage({ id: 'home.howToPlay.item2' })}</li>
                <li>{intl.formatMessage({ id: 'home.howToPlay.item3' })}</li>
                <li>{intl.formatMessage({ id: 'home.howToPlay.item4' })}</li>
                <li>{intl.formatMessage({ id: 'home.howToPlay.item5' })}</li>
              </ul>
            </div>
            <button 
              className="mt-8 bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition duration-300"
              onClick={scrollToGame}
            >
              {intl.formatMessage({ id: 'home.startPlaying' })}
            </button>
          </div>
          <div className="md:w-1/2">
            <img
              src="/pokemon-silhouette.avif"
              alt="Pokémon Silhouette for Pokedle Game"
              className="mx-auto object-cover rounded-lg shadow-xl w-full max-w-[500px] h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GameIntro;
